
export default function deprecated(message) {
    if (process.env.NODE_ENV !== 'production') {
        console.warn(`DEPRECATED: ${message}`);
    }
}



// WEBPACK FOOTER //
// ./~/@99designs/react-components/lib/deprecated.js